var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFloor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.st1{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "49.32,84.53 53.97,88.54 55.2,87.65 55.22,81.1  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 53.97,
    y1: 88.54,
    x2: 53.97,
    y2: 81.89
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "67.91,73.92 72.57,77.92 73.8,77.03 73.82,70.48  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 72.57,
    y1: 77.92,
    x2: 72.57,
    y2: 71.27
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "84,64.63 88.66,68.63 89.89,67.74 89.9,61.19  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 88.66,
    y1: 68.63,
    x2: 88.66,
    y2: 61.98
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "97.82,56.3 97.82,50.76 55.4,14.81 2.06,45.85 2.06,51.22 44.6,87.27  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "97.82,50.76 44.47,81.8 44.6,87.27  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 44.47,
    y1: 81.8,
    x2: 2.06,
    y2: 45.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 97.9,
    y1: 54.24,
    x2: 44.55,
    y2: 85.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 2.06,
    y1: 49.1,
    x2: 44.55,
    y2: 85.12
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFloor);
export default __webpack_public_path__ + "static/media/IconFloor.61a30daea2e696e415ca8313d51d45a8.svg";
export { ForwardRef as ReactComponent };